import { Autocomplete, FormControl, ListItemIcon, ListItemText, MenuItem, TextField } from '@mui/material';
import { NShiftPartner } from 'models/nshift-partners';
import React, { FC, Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AddIcon from '@mui/icons-material/Add';
import DelayedLinearProgress from 'components/shared/delayed-linear-progress/delayed-linear-progress.component';

type NShiftPartnersAutoCompleteProps = {
    loading: boolean;
    nShiftPartners: NShiftPartner[];
    onPartnerSelect: (partner: NShiftPartner) => void;
};

const NShiftPartnersAutoComplete: FC<NShiftPartnersAutoCompleteProps> = ({
    loading,
    nShiftPartners,
    onPartnerSelect,
}: NShiftPartnersAutoCompleteProps) => {
    const { t: translate } = useTranslation(['transport', 'orders']);
    const [inputValue, setInputValue] = useState('');

    const handlePartnerSelect = (_: React.SyntheticEvent, selectedPartner: NShiftPartner | any) => {
        setInputValue('');
        onPartnerSelect(selectedPartner);
    };

    return (
        <Fragment>
            <FormControl fullWidth>
                <Autocomplete
                    fullWidth
                    disableClearable
                    options={nShiftPartners}
                    sx={{ minWidth: 300 }}
                    id="nshift-partner-label"
                    inputValue={inputValue}
                    noOptionsText={translate('orders:TYPE_TO_SEARCH')}
                    getOptionLabel={(option: NShiftPartner | string) => {
                        if (typeof option === 'string') {
                            return option;
                        }
                        return `${option.description} (${option.id})`;
                    }}
                    isOptionEqualToValue={(option: NShiftPartner, value: NShiftPartner) => option.id === value.id}
                    renderOption={(props, option: NShiftPartner) => (
                        <MenuItem {...props} key={option.id} value={option.id}>
                            <ListItemIcon>
                                <AddIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>
                                {option.description} ({option.id})
                            </ListItemText>
                        </MenuItem>
                    )}
                    onChange={handlePartnerSelect}
                    renderInput={(params) => <TextField {...params} label={translate('transport:SELECT_PARTNER')} />}
                    onInputChange={(_, value, reason) => {
                        if (reason === 'reset') {
                            setInputValue('');
                            return;
                        }
                        setInputValue(value);
                    }}
                />
            </FormControl>
            {loading ? <DelayedLinearProgress /> : undefined}
        </Fragment>
    );
};

export default NShiftPartnersAutoComplete;
